import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import RefreshIcon from "../../../../assets/common/icons/refresh_icon.svg";
import BriaButton from "../../../../components/common/BriaButton/BriaButton";
import { useAppStore } from "../../../../hooks/useStores";
import styles from "./AdvancedImageLoadingError.module.scss";

type Props = {
	onTryAgain: () => void;
};

const AdvancedImageLoadingError = ({ onTryAgain }: Props) => {
	const { t } = useTranslation("tg", { keyPrefix: "advancedUploadPanels.error" });
	const { tgStore } = useAppStore();
	const { tgDatasetStore } = tgStore;
	const [loading, setLoading] = useState(false);

	const handleTryAgain = async () => {
		setLoading(true);
		try {
			if (tgDatasetStore.datasetForm.id) {
				await tgDatasetStore.deleteDataset(tgDatasetStore.datasetForm.id);
			}
			// preserve values but reset id
			tgDatasetStore.datasetForm.id = NaN;
			tgDatasetStore.imagesZipUrl = undefined;
		} finally {
			setLoading(false);
			onTryAgain();
		}
	};

	return (
		<Box className={styles.container}>
			<Typography className={styles.title}>{t("title")}</Typography>
			<Typography className={styles.description}>{t("description1")}</Typography>
			<Typography className={styles.description}>{t("description2")}</Typography>
			<BriaButton
				buttonType="primaryMedium"
				onClick={handleTryAgain}
				className={styles.tryAgainBtn}
				loading={loading}
				disabled={loading}
			>
				<img alt={"try again"} src={RefreshIcon} className={styles.refreshIcon} />
				{t("tryAgain")}
			</BriaButton>
		</Box>
	);
};

export default observer(AdvancedImageLoadingError);
